import gql from "graphql-tag"
import getQueryNames from "@irati/utils/services/apollo/helpers/getQueryNames"
import fullDeal from "../fragments/fullTag"

const query = gql`
  mutation CreateTag($data: TagInput!, $withChildren: Boolean!) {
    createTag(data: $data) {
      ...fullTag
    }
  }
  ${fullDeal}
`

export const createTagKey = getQueryNames(query)[0]

export default query
